<template>
	<article v-if="featuredShop && !featuredShop.default" class="post featured">
		<header class="major">
			<span class="date mb-0">Aktueller Livestream</span>
      <p class="mb-2">{{getFormatedDate(featuredShop.date,featuredShop.duration)}}</p>
			<h2>{{featuredShop.title}}</h2>
      <p>{{featuredShop.author}}</p>
			<p class="">{{featuredShop.teaser}}</p>

		</header>
    <RTStreamIncludingCountdown :stream="featuredShop" :forceLive="showTv">
      <RTProjectDonation :project="featuredProject" :stream_id="featuredShop.id"/>
    </RTStreamIncludingCountdown>
    <ul class="actions special">
			<li class="w-100"><router-link class="w-100 primary button" :to="'/stream/'+featuredShop.id"><i class='icon solid fa-lg fa-info-circle mr-1'></i>Mehr zum Stream und Projekt</router-link></li>
		</ul>
    
	</article>
</template>

<script>
import RTProjectDonation from '@/components/RTProjectDonation.vue'
import RTStreamIncludingCountdown from '@/components/RTStreamIncludingCountdown.vue'
import {shopBase} from '@/mixins/shopBase.js'
import {projectBase} from '@/mixins/projectBase.js'
import {helper} from '@/mixins/helper.js'
export default {
  name: 'RTStreamProgram',
  mixins:[shopBase,helper,projectBase],
  components: {
    RTProjectDonation,
    RTStreamIncludingCountdown
  },
  data: function() {
    return {
      
    };
  },
  watch:{
  },
  computed:{
    showTv(){
      return null!=this.getLastStreamObject;
    },
   
    featuredProject(){
      return (this.featuredShop)?this.getProjectById(this.featuredShop.project_id):null;
    },
    featuredShop(){
      if(this.getLastStreamObject){
        return this.getLastStreamObject;
      }
      return (this.getCurrentShop)?this.getCurrentShop:this._.first(this.getUpcomingShops);
    },
   
  },
  methods:{
  },
};
</script>

<style scoped type='text/css'>
.cover{
  max-width: 100%;
  max-height: 400px;
}

.streamInfoTxt{
  text-align: center;
  font-style: italic;
}

</style>